module.exports = __webpack_public_path__ + "fonts/IBMPlexMono-Regular.7eaa73b0.eot";